import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { ApplePay } from '../../payment-methods/ApplePay';
import { PayPal } from '../../payment-methods/PayPal';
import { GooglePay } from '../../payment-methods/GooglePay';
import {
  PaymentsButtonPlace,
  AvailablePmsList,
  PaymentMethodSourceName,
} from '../../../types/PaymentsButtonViewConfig';
import { getButtonsViewConfig, SeparatedButtonsViewConfig } from '../utils/getButtonsViewConfig';
import { selectGooglePayButton } from '../../../selectors/googlePay';
import { DH } from '../../../utils/dataHooks';
import s from '../styles.scss';

interface PaymentButtonStrategyProps {
  name: PaymentMethodSourceName;
  place: PaymentsButtonPlace;
}

const PaymentButtonStrategy: React.FC<PaymentButtonStrategyProps> = ({ name, place }) => {
  let component: ReactNode = null;
  const googlePayButton = useSelector(selectGooglePayButton);

  switch (name) {
    case PaymentMethodSourceName.ApplePay:
      component = <ApplePay />;
      break;
    case PaymentMethodSourceName.GooglePay:
      component = <GooglePay place={place} />;
      break;
    case PaymentMethodSourceName.PayPal:
    case PaymentMethodSourceName.PayPalCredit:
    case PaymentMethodSourceName.PayPalPayLater:
    case PaymentMethodSourceName.PayPalVenmo:
      component = <PayPal fundingSource={name} place={place} />;
      break;
  }

  // if Google decided to not show button, we should remove wrapper too
  if (name === PaymentMethodSourceName.GooglePay && googlePayButton.visibility === 'hidden') {
    return null;
  }

  return (
    <div data-hook={DH.Widget.PMListItem(name)} className={s.layoutItem}>
      {component}
    </div>
  );
};

export const AllExpressButtons: React.FC<{ pmsList: AvailablePmsList }> = ({ pmsList }) => {
  const viewConfig = getButtonsViewConfig(pmsList);
  return (
    <>
      {viewConfig.map((item) => (
        <PaymentButtonStrategy key={item.name} name={item.name} place="onTopLevel" />
      ))}
    </>
  );
};

export const ExpressButtonsOnTopLevel: React.FC<{ viewConfig: SeparatedButtonsViewConfig }> = ({ viewConfig }) => {
  return (
    <>
      {viewConfig.onTopLevel.map((item) => (
        <PaymentButtonStrategy key={item.name} name={item.name} place="onTopLevel" />
      ))}
    </>
  );
};

export const ExpressButtonsInsideShowMore: React.FC<{ viewConfig: SeparatedButtonsViewConfig }> = ({ viewConfig }) => {
  return (
    <>
      {viewConfig.insideShowMore.map((item) => (
        <PaymentButtonStrategy key={item.name} name={item.name} place="insideShowMore" />
      ))}
    </>
  );
};
